import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import i18n from '../i18n'
import * as api from './../helpers/api'

Vue.use(Vuex);

let $store = null;

const state = {
	eventsList: [],
	filteredEventsList: [],
	pastEventsCounter: 0,
	upcomingEventsCounter: 0,
	checkedFilter: [],
	activeFilters: {},
	filters: {},
	calendarEvents: [],
	selectedDate: {},
	filtersInfo: {},
	query: {},
	localQueryParams: {},
	currentPage: 1,
	queryNotFound: false
};

// actions
const actions = {
	//get main data
	async getData ({ dispatch }) {
		//for access to global Store
		$store = this;
		try {
			await api.getEvents()
				.then(response => {
					if (response.data) {
						dispatch('setData', response.data)}
				})
		} catch (error) {
			console.error(error)
		}
	},
	setData: ({ commit, dispatch }, response ) => {
		const eventsList = [...response.events];
		const filters = {...response.filters};
		// set data to store
		commit('SET_DATA', { eventsList, filters } );
		//get data about filters
		dispatch('setFiltersInfo');
		// if there are query parameters, then load with them
		if (Object.keys(router.currentRoute.query).length) {
			dispatch('loadQueryParams', router.currentRoute.query)
		} else {
			//create two arrays upcoming and past events, recount counter
			dispatch('createUpcomingPastEvents');
			// set events to calendar
			dispatch('setEventsToCalendar', eventsList);
		}
	},

	setFiltersInfo: ({ commit } ) => {
		//get info about filters, where the key is category id and the value is category label
		let filterInfo = {};
		if (Object.keys(state.filters).length) {
			for (let filter in state.filters) {
				filterInfo[state.filters[filter].id] = filter;
			}
		}
		commit('SET_FILTERS_INFO', filterInfo);
	},

	setEventsToCalendar: ({ commit, store },  eventsList ) => {
		// create current date
		const today = {
			key: 'today',
			dates: new Date(),
			highlight: 'blue',
		};
		// we go through all the events and add them to the calendar
		let calendarEvents = eventsList.map( event => {
			return {
				key: 'events',
				dates: new Date(event.start_date),
				highlight: 'gray',
				id: event.id,
				title: event.title,
			};
		});
		calendarEvents.push(today);
		commit('SET_EVENTS_TO_CALENDAR', calendarEvents);
	},

	setDateToStore: ({ dispatch, commit, store }, date ) => {
		//we get the date from query, translate it into the desired format
		let dateItem = Object.assign({}, date);
		let start = $store._vm.$dayjs(dateItem.start);
		let end = $store._vm.$dayjs(dateItem.end).hour(23).minute(59);
		// if we chose the same day in range
		if (start.diff(end, 'day') === 0) {
			//then write in short format
			dateItem.value = i18n.d(start, 'short', window.events_data.locale);
		} else {
			//if the days are different - then write them through a dash
			dateItem.value = i18n.d(start, 'short', window.events_data.locale) + " - " + i18n.d(end, 'short', window.events_data.locale);
		}
		dateItem.start = start.toDate();
		dateItem.end = end.toDate();

		//write new data to store
		commit('SET_DATE_TO_STORE', dateItem);
		dispatch('sortByDate');
	},

	sortByDate: ({ dispatch, commit }) => {
		// filtering according to selected filters
		let filteredEventList;
		if ( Object.keys(state.activeFilters).length ) {
			filteredEventList = state.filteredEventsList;
		} else {
			filteredEventList = state.eventsList;
		}

		const rangeStart = $store._vm.$dayjs(state.selectedDate.start);
		const rangeEnd = $store._vm.$dayjs(state.selectedDate.end);

		filteredEventList = filteredEventList.filter( filteredEvent => {
			const eventStart = $store._vm.$dayjs(filteredEvent.start_date);
			let eventEnd = filteredEvent.end_date ? $store._vm.$dayjs(filteredEvent.end_date) : eventStart.hour(23).minute(59);

			return eventStart <= rangeEnd && eventEnd >= rangeStart
		});

		commit('SET_FILTERED_BY_DATE_LIST', filteredEventList);
		dispatch('createUpcomingPastEvents');
	},
	createUpcomingPastEvents: ({ commit } ) => {
		//goes through the general array of events, checks the date with the current one and splits it into two arrays, past and upcoming
		let upcomingEvents = [];
		let pastEvents = [];
		let dateNow = $store._vm.$dayjs();

		state.filteredEventsList.forEach( event => {
			event.start_date = $store._vm.$dayjs(event.start_date).format();
			event.end_date = $store._vm.$dayjs(event.end_date).format();

			if ($store._vm.$dayjs(event.end_date) > dateNow) {
				upcomingEvents.push(event);
				event.status = 'upcoming';
			} else {
				pastEvents.push(event);
				event.status = 'past';
			}
		});
		//sorts both arrays by date
		upcomingEvents.sort( (a, b) => {
			return  $store._vm.$dayjs( a.start_date ) - $store._vm.$dayjs( b.start_date )
		});
		pastEvents.sort( (a, b) => {
			return  $store._vm.$dayjs( b.start_date ) - $store._vm.$dayjs( a.start_date )
		});

		//mutate new array to store
		commit('SET_UPCOMING_PAST_EVENTS', { upcomingEvents, pastEvents });
	},

	setCheckboxesQueryParams: ({ dispatch, commit, state },  payload ) => {
		commit('QUERY_NOT_FOUND', false);
		commit('SET_CHECKBOXES_QUERY_PARAMS', payload );
		commit('SET_PAGER', 1 );
	},
	setDateQueryParams: ({ dispatch, commit, state },  date ) => {
		commit('SET_DATE_QUERY_PARAMS', date);
		commit('SET_PAGER', 1 );
	},

	loadQueryParams: ({ dispatch, commit }, query ) => {
		//since the checkbox looks in the state at the checked checkbox - we need to make an imitation of the checked checkbox
		let localQuery = Object.assign({}, query);
		let filters = ['date', 'regions', 'industries', 'types'];
		let selectedFilter = [];

		//we look at query parameters and create an object with the necessary parameters for the checkbox
		if (Object.keys(localQuery).length) {

			// unset all query parameters but the filters
			for (let parameter in localQuery) {
				if (!filters.includes(parameter) ){
					delete localQuery[parameter];
				}
			}

			// if there is a date - need to process it, send it to the store and remove it from the localQuery
			if (localQuery.date) {
				localQuery.date = localQuery.date.split(',');
				let date = {};
				// then we replace "-" with "/" due to unsupported safari and firefox
				date.start = localQuery.date[0].replace(/-/g, '/');
				date.end = localQuery.date[1].replace(/-/g, '/');
				delete localQuery.date;
				dispatch('removeSortingEvents');
				// send the received date to the store to draw the tag
				dispatch('setDateToStore', date);
			}
			// if there are filters in addition to the date
			if (Object.keys(localQuery).length) {
				for (let category in localQuery) {
					if (filters.includes(category) && localQuery.hasOwnProperty(category)) {
						localQuery[category] = localQuery[category].split(',');

						localQuery[category].forEach(queryLabel => {
							if (state.filters[category].items.find(item => item.label === queryLabel)) {
								//create objects of the selected filter
								let filterItem = {
									label: queryLabel,
									status_checked: true,
									id: getFilterId(category),
									filterName: category,
									filterIndex: getFilterIndex(queryLabel, state.filters[category].items)
								};
								selectedFilter.push(filterItem);
							} else {
								commit('QUERY_NOT_FOUND', true);
								commit('CLEAR_FILTERING');
							}

						});

						if (!state.queryNotFound)  {
							commit('SET_VALUE_FROM_QUERY', selectedFilter);
							dispatch('removeSortingEvents');
							dispatch('sortByFilter')
						}
					}
				}
			} else {
				// if there are no more filters, we clean the store
				commit('REMOVE_CHECKBOX_TAG_FILTER');
				dispatch('removeSortingEvents');
				dispatch('sortByFilter');
				if (Object.keys(state.selectedDate).length) {
					dispatch('sortByDate');
				}
			}
		} else {
			//if there are no filters at all - remove all filters from the store
			commit('REMOVE_ALL_TAG_FILTERS');
			dispatch('removeSortingEvents');
			dispatch('sortByFilter');
			if (Object.keys(state.selectedDate).length) {
				dispatch('sortByDate');
			}
		}

		function getFilterId(filterCategory) {
			for (let filter in state.filtersInfo) {
				if (state.filtersInfo[filter] === filterCategory) {
					return filter
				}
			}
		}
		function getFilterIndex(filterLabel, filterItems) {
			return filterItems.findIndex(filterItem => filterItem.label === filterLabel)
		}
	},
	removeSortingEvents: ({ dispatch, commit } ) => {
		commit('REMOVE_SORTING_EVENTS' );
		if (Object.keys(state.selectedDate).length) {
			dispatch('sortByDate');
		}
	},
	sortByFilter: ({ dispatch, commit } ) => {
		// creating an object from the selected filters by category, where the key is id, value is an array of labels
		const activeFilters = {};
		state.checkedFilter.forEach(filter => {
			if (!activeFilters.hasOwnProperty(filter.id)) {
				activeFilters[filter.id] = [];
			}
			if (!activeFilters[filter.id].includes(filter.label)) {
				activeFilters[filter.id].push(filter.label);
			}
		});

		// filtering according to selected filters
		let filteredEventList;
		if ( state.filteredEventsList.length ) {
			filteredEventList = state.filteredEventsList;
		} else {
			filteredEventList = state.eventsList;
		}
		for (let id in activeFilters) {
			filteredEventList = filteredEventList.filter( event => activeFilters[id].includes(event.filters[id]))
		}
		//store mutation
		commit('SET_FILTERED_LIST', { filteredEventList , activeFilters } );
		dispatch('createUpcomingPastEvents');
		dispatch('setEventsToCalendar', filteredEventList);
	},
	removeCheckedFilters: ({ dispatch, commit, state },  tagLabel ) => {
		commit('SET_CHECKBOXES_QUERY_PARAMS', tagLabel);
		commit('REMOVE_TAG_FILTER', tagLabel);
		commit('SET_PAGER', 1 );
		dispatch('sortByFilter');
		if (Object.keys(state.selectedDate).length) {
			dispatch('sortByDate');
		}
	},
	removeDateFilters: ({ dispatch, commit } ) => {
		commit('REMOVE_DATE_TAG_FILTER');
		commit('SET_PAGER', 1 );
		dispatch('removeSortingEvents');
	},
	removeAllFilters: ({ dispatch, commit } ) => {
		commit('REMOVE_ALL_QUERY_PARAMS');
		commit('SET_PAGER', 1 );
	},
	setPageParams: ({ dispatch, commit, state },  page ) => {
		commit('SET_PAGER', page );
	},
};
// mutations
const mutations = {
	'SET_DATA' ( state, data ) {
		state.eventsList = data.eventsList;
		state.filteredEventsList = data.eventsList;
		state.filters = data.filters;
	},

	'SET_EVENTS_TO_CALENDAR' ( state, calendarEvents ) {
		state.calendarEvents = calendarEvents;
	},
	'SET_DATE_TO_STORE' ( state, dateItem ) {
		state.selectedDate = dateItem;
	},
	'SET_FILTERS_INFO' ( state, filterInfo ) {
		state.filtersInfo = filterInfo;
	},
	'SET_UPCOMING_PAST_EVENTS' ( state, data ) {
		state.upcomingEventsCounter = data.upcomingEvents.length;
		if (window.events_data.featured_event && window.events_data.featured_event.title){
			state.upcomingEventsCounter += 1;
		}
		state.pastEventsCounter = data.pastEvents.length;
		state.filteredEventsList = [...data.upcomingEvents, ...data.pastEvents];
	},
	'SET_FILTERED_LIST' ( state, data ) {
		//data = filteredEventList, activeFilters
		state.filteredEventsList = data.filteredEventList;
		state.activeFilters = data.activeFilters
	},
	'SET_FILTERED_BY_DATE_LIST' ( state, filteredEventList ) {
		state.filteredEventsList = filteredEventList;
	},
	'SET_VALUE_FROM_QUERY' ( state, queryFilters ) {
		let query = Object.assign({}, state.query);
		// going through the array of filters and change the status_checked for the selected filter
		for (let filter in state.filters) {
			if (state.filters.hasOwnProperty(filter)) {
				state.filters[filter].items.forEach( filterItem => {
					filterItem.status_checked = false;
				})
			}
		}
		// set new data for the selected filter
		queryFilters.forEach( queryFilter => {
			let filterItem = state.filters[queryFilter.filterName].items[queryFilter.filterIndex];
			filterItem.status_checked = queryFilter.status_checked;
			filterItem.id = queryFilter.id;
			filterItem.filterName = queryFilter.filterName;

			// if there is no such category in state.query then create an empty array
			if (!query[queryFilter.filterName]) {
				query[queryFilter.filterName] = []
			} else {
				// if there is already a category - then add the category, separated by commas, to the array
				query[queryFilter.filterName] = query[queryFilter.filterName].split(',');
			}
			// if the category does not have the current filter label - add to the array
			if (!query[queryFilter.filterName].includes(queryFilter.label)) {
				query[queryFilter.filterName].push(queryFilter.label);
			}

			// glue the value to the string
			if (query[queryFilter.filterName].length) {
				query[queryFilter.filterName] = query[queryFilter.filterName].join(',');
			}
		});
		state.checkedFilter = queryFilters;
		state.query = Object.assign({}, query);
	},
	'SET_CHECKBOXES_QUERY_PARAMS'(state, payload) {
		// payload = filterIndex, itemIndex, value, filterItem, filterId
		// get query from the state
		let query = Object.assign({}, state.query);
		// if we remove the filter tag - the label comes with typeof === string
		if (typeof payload === "string") {
			for (let queryItem in query) {
				if (query.hasOwnProperty(queryItem)) {
					query[queryItem] = query[queryItem].split(',');
					query[queryItem] = query[queryItem].filter( filterItem => {
						return filterItem !== payload
					});
					if (query[queryItem].length) {
						query[queryItem] = query[queryItem].join(',');
					} else {
						delete query[queryItem]
					}
				}
			}
		} else {
			// if there is no such category in state.query then create an empty array
			if (!query[payload.filterIndex]) {
				query[payload.filterIndex] = []
			} else {
				// if there is already a category - then add the category, separated by commas, to the array
				query[payload.filterIndex] = query[payload.filterIndex].split(',');
			}
			// if the category does not have the current filter label - add to the array
			if (!query[payload.filterIndex].includes(payload.filterItem.label)) {
				query[payload.filterIndex].push(payload.filterItem.label);
			} else {
				// if there is - delete from the array
				query[payload.filterIndex] = query[payload.filterIndex].filter( item => {
					return item !== payload.filterItem.label
				});
			}

			// glue the value to the string
			if (query[payload.filterIndex].length) {
				query[payload.filterIndex] = query[payload.filterIndex].join(',');
			} else {
				delete query[payload.filterIndex]
			}
		}
		state.query = Object.assign({}, query);
		router.push({ query: state.query}).catch(err => {});
	},
	'SET_DATE_QUERY_PARAMS'(state, date) {
		// we get the date, format the date for output to query and push into the router
		// and starts action loadQueryParams
		if (Object.keys(date).length) {
			let query = {};
			query.date = $store._vm.$dayjs(date.start).format('MM-DD-YY') + ',' + $store._vm.$dayjs(date.end).format('MM-DD-YY');
			state.query.date = query.date;
		} else {
			// if there is no data (when deleting), delete the date from the query
			delete state.query.date;
		}
		// after deleting data from the router and starts loadQueryParams action
		router.push({ query: state.query }).catch(err => {});
	},
	'REMOVE_ALL_QUERY_PARAMS'(state) {
		state.query = {};
		router.push({ query: state.query}).catch(err => {});
	},
	'REMOVE_SORTING_EVENTS' ( state ) {
		state.upcomingEventsCounter = 0;
		state.pastEventsCounter = 0;
		state.filteredEventsList = state.eventsList
	},
	'REMOVE_TAG_FILTER' ( state, tagLabel ) {
		for (let filter in state.filters) {
			if (state.filters.hasOwnProperty(filter)) {
				state.filters[filter].items.forEach( filterItem => {
					if (filterItem.label === tagLabel) {
						filterItem.status_checked = false;
					}
				})
			}
		}
		state.checkedFilter = state.checkedFilter.filter( item => {
			return item.label !== tagLabel
		});
	},
	'REMOVE_DATE_TAG_FILTER' ( state ) {
		state.selectedDate = {};
	},
	'REMOVE_CHECKBOX_TAG_FILTER' ( state ) {
		for (let filter in state.filters) {
			if (state.filters.hasOwnProperty(filter)) {
				state.filters[filter].items.forEach( filterItem => {
					filterItem.status_checked = false
				})
			}
		}
		state.checkedFilter = [];
	},
	'REMOVE_ALL_TAG_FILTERS' ( state ) {
		for (let filter in state.filters) {
			if (state.filters.hasOwnProperty(filter)) {
				state.filters[filter].items.forEach( filterItem => {
					filterItem.status_checked = false
				})
			}
		}
		state.checkedFilter = [];
		state.selectedDate = {};
	},
	'SET_PAGER' ( state, page ) {
		state.currentPage = page;
	},
	'QUERY_NOT_FOUND' ( state, value ) {
		state.queryNotFound = value;
	},
	'CLEAR_FILTERING' ( state ) {
		state.upcomingEventsCounter = 0;
		state.pastEventsCounter = 0;
		state.filteredEventsList = []
	},

};

//getters
const getters = {
	eventsList: 			state => state.eventsList,
	filteredEventsList: 	state => state.filteredEventsList,
	pastEventsCounter: 		state => state.pastEventsCounter,
	upcomingEventsCounter: 	state => state.upcomingEventsCounter,
	checkedFilter: 			state => state.checkedFilter,
	filters: 				state => state.filters,
	calendarEvents: 		state => state.calendarEvents,
	selectedDate: 			state => state.selectedDate,
	activeFilters: 			state => state.activeFilters,
	currentPage: 			state => state.currentPage,
};

export default new Vuex.Store({
	state,
	mutations,
	actions,
	getters,
})
